import { createTheme } from '@mui/material';

export const customTheme = createTheme({
  palette: {
    primary: { main: '#06806B' },
    secondary: { main: '#5C5C5C' },
  },
});
